import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Newspaper, Plus, Users } from 'lucide-react'
import { cn } from '@/lib/utils'

const AdminPanelSidebar = ({ collapsed }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const items = [
    { key: '/admin-panel', icon: Newspaper, label: 'Blogs' },
    // { key: '/admin-panel/blogs/new', icon: Plus, label: 'New Post' },
    { key: '/admin-panel/authors', icon: Users, label: 'Authors' },
  ]

  return (
    <nav className="space-y-0.5">
      {items.map((item) => {
        const Icon = item.icon
        const isActive = location.pathname === item.key
        return (
          <button
            key={item.key}
            onClick={() => navigate(item.key)}
            className={cn(
              'w-full flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors',
              isActive
                ? 'bg-gray-100 text-sidebar-foreground font-medium dark:bg-sidebar-accent dark:text-sidebar-accent-foreground'
                : 'text-sidebar-foreground/70 hover:bg-gray-100 hover:text-sidebar-foreground dark:hover:bg-sidebar-accent dark:hover:text-sidebar-accent-foreground',
              collapsed && 'justify-center px-2'
            )}
          >
            <Icon className="h-4 w-4 shrink-0" />
            {!collapsed && <span>{item.label}</span>}
          </button>
        )
      })}
    </nav>
  )
}

export default AdminPanelSidebar
